const types = {
  INIT: "INIT",
  INCREASE: "INCREASE",
  DECREASE: "DECREASE",
  DURATION: "ADD DURATION",
  SET_LOCATION: "SET_LOCATION",
  SET_CURRENCY: "SET_CURRENCY",
  RESET_DELIVERY_AMOUNT: "RESET_DELIVERY_AMOUNT"
};

export default types;
